import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ERPDocumentService {

  private URL = environment.api+"api/erp/documents";

  constructor(private http: HttpClient) { }
  
  getInventoryChronology(warehouseId:number, startDate: number, endDate: number){
	if (warehouseId){
		return this.http.get(this.URL + `/chronology/${warehouseId}/${startDate}/${endDate}`);
	} else {
		return this.http.get(this.URL + `/chronology/general/${startDate}/${endDate}`);
	}
  }
}
